import React from "react";
import Navbar from "./Navbar";
import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon } from "@heroicons/react/20/solid";
import { useEffect, useState } from "react";
import Footer from "./Footer";
const Feedback = () => {
  const [feedback, setFeedback] = React.useState([]);
  const [allfeedback, setAllFeedback] = React.useState([]);
  const [search, setSearch] = useState("");

    
  const loadFeedbackList = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_SERVER_URL + "/contact/getAllFeedback",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      const data = await response.json();
      console.log(data);

      setFeedback(data.allFeedback);
      console.log(feedback);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    setAllFeedback(feedback)
    if (search !== "") {
      let filteredBuyers = feedback.filter((item) =>
        item.email.toLowerCase().includes(search.toLowerCase())
      );
      setAllFeedback(filteredBuyers);
    } else {
      setAllFeedback(feedback);
    }
    // loadFeedbackList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, feedback]);

  React.useEffect(() => {
    loadFeedbackList();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      <Navbar />
      <div
        className="text-3xl w-full font-bold bg-gradient-to-l from-green-200 to-green-500"
        style={{ textAlign: "center" }}
      >
        <p className="pt-2"> Feedbacks</p>
      </div>

      <div className=" flex flex-row items-center">
        <div className="m-2 mt-8 bg-slate-500 px-3 py-1 text-green-400 rounded-2xl font-bold">
          Search
        </div>
        <input
          type="text"
          placeholder="      Buyer Email"
          className="mt-5 ml-3 dark:bg-black dark:text-white bg-gray-200 border border-gray-400 rounded-2xl py-2 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-green-600 focus:border-transparent"
          onChange={(e) => {
            setSearch(e.target.value);
          }}
        />
      </div>

      <div className="w-full px-4 pt-10 min-h-screen">
        <div className="m-auto w-full rounded-2xl bg-white p-2 text-center">
          {allfeedback.length > 0 ? (
            allfeedback.map((item, index) => {
              return (
                <Disclosure as="div" className="container mt-2 w-full">
                  {({ open }) => (
                    <>
                      <Disclosure.Button className="flex flex-row w-full justify-around rounded-lg bg-green-400 px-4 py-2 text-left text-sm font-medium text-grey-900 hover:bg-green-300 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                        <div className="w-full sm:w-1/2 md:w-1/2 lg:w-1/6">
                          {item.name}
                        </div>
                        <div className="flex flex-row justify-end w-full sm:w-1/2 md:w-1/2 lg:w-1/2">
                          <div className="">{item.email}</div>
                          <ChevronUpIcon
                            className={`${
                              open
                                ? "rotate-180 transform w-full sm:w-1/6 md:w-1/6 lg:w-1/6"
                                : ""
                            } h-5  text-purple-500 w-full sm:w-1/6 md:w-1/6 lg:w-1/6"`}
                          />
                        </div>
                      </Disclosure.Button>
                      <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500 bg-green-100">
                        <div className="openmsg flex flex-row justify-between">
                          {item.message}
                          <p className="text-rose-800">
                            <a href={`mailto:${item.email}`}>Send email</a>
                          </p>
                        </div>
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>
              );
            })
          ) : (
            <h1 className="">Data Not Found</h1>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Feedback;
